module.exports = __webpack_public_path__ + "static/about-87a60a2e88c1e98f1b1a09d0e28eeab2.svg";